module.exports = __webpack_public_path__ + "img/VISA.f5759b19.svg";